export { Badge } from './Badge';
export type { BadgeProps } from './Badge';
